/* eslint-disable */
import React, { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XIcon } from "@heroicons/react/outline";

export default function Reset({ isOpen = false, setIsOpen }) {
  const [step, setStep] = useState(1);
  const [loading, setloading] = useState(false);
  const [resendBool, setresendBool] = useState(false);

  function closeModal() {
    setStep(1);
    setIsOpen(false);
  }

  const openModal = () => {
    setIsOpen(true);
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    setloading(true);

    if (step === 1) {
      setTimeout(() => {
        setloading(false);
        setStep(2);
      }, 2000);
    } else {
      setTimeout(() => {
        setStep(1);
        setloading(false);
        closeModal();
      }, 2000);
    }
  };

  const ResendOTP = (e) => {
    e.preventDefault();

    setresendBool(true);
    setTimeout(() => {
      setresendBool(false);
    }, 2000);    
  };

  const Loader = ({ color="text-white" }) => (
    <svg
      class={`animate-spin -ml-1 mr-3 h-5 w-5 ${color}`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        class="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="4"
      ></circle>
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  );

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            className="fixed inset-0 bg-black bg-opacity-25 backdrop-blur-sm"
            onClick={closeModal}
          />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="relative text-left p-4 sm:p-6 md:p-10 bg-oya-ghana-modal-background border border-oya-ghana-border shadow-form rounded-xl">
                <div className="flex items-start justify-between">
                  <div className="flex items-start space-x-4">
                    <img src="/assets/images/login/reset.png" alt="" />
                    <h3 className="text-oya-ghana-header-h5 pb-5">
                      Did You Forget <br className="hidden sm:block" /> Your
                      PIN?
                    </h3>
                  </div>

                  <div
                    className="border-2 border-oya-ghana-border p-2 rounded-full cursor-pointer"
                    onClick={closeModal}
                  >
                    <XIcon className="h-6 w-6 text-black" aria-hidden="true" />
                  </div>
                </div>

                <form className="w-full" onSubmit={handleOnSubmit}>
                  {step === 1 && (
                    <div className="w-full mb-6">
                      <label className="text-gray-500 text-sm">
                        Enter Your Phone Number
                      </label>
                      <input
                        type="number"
                        autoComplete="off"
                        required
                        className="w-full px-4 mt-2 bg-white border border-gray-200 outline-none rounded-md h-10"
                      />{" "}
                    </div>
                  )}

                  {step === 2 && (
                    <>
                      <p className="text-sm py-5">
                        We’ve sent you a One Time Pin to your SMS inbox, <br />
                        enter it below to get started.
                      </p>

                      <div className="w-full mb-6">
                        <label className="text-gray-500 text-sm">
                          OTP Sent To Your Number
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          required
                          className="w-full px-4 mt-2 bg-white border border-gray-200 outline-none rounded-md h-10"
                        />{" "}
                      </div>

                      <div className="w-full mb-6">
                        <label className="text-gray-500 text-sm">
                          Enter Your New PIN
                        </label>
                        <input
                          type="password"
                          autoComplete="off"
                          required
                          className="w-full px-4 mt-2 bg-white border border-gray-200 outline-none rounded-md h-10"
                        />{" "}
                      </div>
                    </>
                  )}

                  {step === 2 && (
                    <button
                      className="w-full trans flex items-center justify-center mt-5 border border-oya-ghana-green text-oya-ghana-green text-oya-ghana-header-h6 rounded-md py-2 text-white"
                      onClick={ResendOTP}
                    >
                      {resendBool && <Loader color="text-oya-ghana-green" />}
                      Resend
                    </button>
                  )}

                  <button
                    type="submit"
                    className="w-full trans flex items-center justify-center my-5 bg-oya-ghana-green text-oya-ghana-header-h6 rounded-md py-2 text-white"
                  >
                    {loading && <Loader />}
                    Continue
                  </button>
                </form>
              </div>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
